import { combineReducers } from '@reduxjs/toolkit';

import { generalReducer } from './general';
import { userReducer } from './user';

export const rootReducer = combineReducers({
  general: generalReducer,
  user: userReducer,
});
